function setupSelectPopout(selectPopout) {
    var button = selectPopout.querySelector('.c_select-popout__toggle');
    var hiddenInput = selectPopout.querySelector('input[type="hidden"]');
    var optionList = selectPopout.querySelector('.c_select-popout__list');

    button.addEventListener('click', function () {
        optionList.classList.toggle('active');
    });

    var optionItems = optionList.querySelectorAll('.c_select-popout__item');

    optionItems.forEach(function (element) {
        element.addEventListener('click', function () {
            var spanText = element.querySelector('.select-popout__option span').textContent;
            hiddenInput.value = spanText;
            button.textContent = spanText;
            element.querySelector('.c_select-popout__option').classList.add('active');
            optionList.classList.remove('active');
            optionItems.forEach(function (item) {
                if (item !== element) {
                    item.querySelector('.c_select-popout__option').classList.remove('active');
                }
            });
        });
    });

    document.addEventListener('click', function (event) {
        if (
            !button.contains(event.target) &&
            !optionList.contains(event.target)
        ) {
            optionList.classList.remove('active');
        }
    });
}

window.addEventListener('DOMContentLoaded', function () {
    var selectPopouts = document.querySelectorAll('.c_select-popout');
    selectPopouts.forEach(setupSelectPopout);
});

var quickviewModal = document.querySelector('.quickview__modal');

var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.target === quickviewModal && mutation.attributeName === 'class') {
            if (quickviewModal.classList.contains('is-open')) {
                var selectPopouts = document.querySelectorAll('.c_select-popout');
                selectPopouts.forEach(setupSelectPopout);
            } else {
                var selectPopouts = document.querySelectorAll('.c_select-popout');
                selectPopouts.forEach(setupSelectPopout);
            }
        }
    });
});

observer.observe(quickviewModal, { attributes: true });